<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="24" :height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11 21.7299C11.304 21.9054 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9054 13 21.7299L20 17.7299C20.3037 17.5545 20.556 17.3024 20.7315 16.9987C20.9071 16.6951 20.9996 16.3506 21 15.9999V7.9999C20.9996 7.64918 20.9071 7.30471 20.7315 7.00106C20.556 6.69742 20.3037 6.44526 20 6.2699L13 2.2699C12.696 2.09437 12.3511 2.00195 12 2.00195C11.6489 2.00195 11.304 2.09437 11 2.2699L4 6.2699C3.69626 6.44526 3.44398 6.69742 3.26846 7.00106C3.09294 7.30471 3.00036 7.64918 3 7.9999V15.9999C3.00036 16.3506 3.09294 16.6951 3.26846 16.9987C3.44398 17.3024 3.69626 17.5545 4 17.7299L11 21.7299Z" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 22V12" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.28999 7L12 12L20.71 7" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.5 4.27002L16.5 9.42002" :stroke="color ? color : 'black'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ProductIcon',
  props: ['color']
}
</script>
